import { createReducer, createSelector, on } from '@ngrx/store';
import { CAAction } from '../actions';
import { Tenants } from './tenants.actions';
import { TenantDto } from '@careapp-group/ng-sdk';
import { TENANT_ADMINISTRATOR } from '@careapp-group/core';
import { CaEntityReducer } from '../entity-state/entity-reducer';
import { BaseFilterType } from '../entity-state/entity-actions-factory';
import { CaEntityState, INITIAL_ENTITY_STATE } from '../entity-state/entity-state';
import { mergeReducers } from '../entity-state/merge-reducers';

class TenantsState extends CaEntityReducer<TenantDto, BaseFilterType> {
  readonly initialState: CaEntityState<TenantDto> = INITIAL_ENTITY_STATE;

  constructor(actions) {
    super(actions);
  }

  tenantActionsReducer = createReducer(
    this.initialState,

    on(Tenants.requestSaveTenantPlan, (state, { tenantId }) => ({
      ...state,
      loadingEntities: { ...state.loadingEntities, [tenantId]: true },
    })),

    on(Tenants.successSaveTenantPlan, (state, { tenantId, plan }) => ({
      ...state,
      loadingEntities: { ...state.loadingEntities, [tenantId]: false },
      entities: { ...state.entities, [tenantId]: { ...state.entities[tenantId], plan } },
    })),

    on(Tenants.failSaveTenantPlan, (state, { tenantId, error }) => ({
      ...state,
      loadingEntities: { ...state.loadingEntities, [tenantId]: false },
      error,
    })),
  );

  public combinedReducer = mergeReducers(this.tenantActionsReducer, this.entityReducer);

  public reducer(state = this.initialState, action: CAAction | any): CaEntityState<TenantDto> {
    return this.combinedReducer(state, action);
  }
}

export const state = new TenantsState(Tenants);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}

export const createSelectors = (rootReducer) => ({
  isTenantAdmin: createSelector(rootReducer, (state: CaEntityState<TenantDto>) => {
    const selectedTenantId = state?.selectedId;
    return (
      selectedTenantId != null &&
      state?.entities[selectedTenantId]?.permission?.role == TENANT_ADMINISTRATOR
    );
  }),

  getTenants: createSelector(rootReducer, (rootState: CaEntityState<TenantDto>) => rootState),

  currentTenantRoles: createSelector(rootReducer, (state: CaEntityState<TenantDto>): string[] => {
    const selectedTenantId = state?.selectedId;
    if (selectedTenantId != null) {
      const role = state?.entities[selectedTenantId]?.permission?.role;
      return !!role ? [role] : [];
    }
    return [];
  }),
});
